var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('sub-slider',{attrs:{"slider-items":_vm.sliderItems}}),_c('mainGlassProducts'),_c('mainGlassProjects'),_c('mainGlassProductionLines'),_c('mainGlassDownloads'),_c('main-glass-hint')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }